var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hypot-ka pointer"
  }, [_vm.activeDeleteButton ? _c('div', {
    staticClass: "closebtn-broker-app pointer",
    on: {
      "click": function click($event) {
        return _vm.removeApplication();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon extrasmall white",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
    }
  })]) : _vm._e(), _vm.activeDeleteButton ? _c('div', {
    staticClass: "closebtn-broker-app pause pointer",
    on: {
      "click": function click($event) {
        return _vm.pauseApplication();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon extrasmall",
    attrs: {
      "src": "https://cdn.prod.website-files.com/648b04f9d8e52d9524912b4a/68481a9749b52460cc8c2a1f_pause%20button.svg"
    }
  })]) : _vm._e(), _vm.activeDeleteButton ? _c('button', {
    staticClass: "closebtn-broker-app lost pointer",
    attrs: {
      "type": "button",
      "title": "Označiť hypotéku ako prehratú",
      "aria-label": "Označiť hypotéku ako prehratú"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.markAsLost.apply(null, arguments);
      }
    }
  }, [_vm._v(" ! ")]) : _vm._e(), _vm.activeDeleteButton ? _c('div', {
    staticClass: "closebtn-broker-app renew pointer",
    on: {
      "click": function click($event) {
        return _vm.renewApplication();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon extrasmall white",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1c_icons8-reset.svg"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "hypoteka-top w-inline-block mortgage-header"
  }, [_vm.mortgage.coapplicant ? _c('div', {
    staticClass: "position-relative"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f48_two%20applicants%20icon.png",
      "loading": "lazy",
      "alt": ""
    }
  })]) : _c('div', [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "bold blc-color"
  }, [_vm.client !== null ? _c('user-manager-handler', {
    attrs: {
      "class-cst": 'blc-color',
      "rules": ['priority'],
      "client-info": _vm.client,
      "mortgages": {
        stage: this.stage,
        id: this.mortgage.id
      },
      "client": ""
    }
  }) : _vm._e(), _vm.mortgage.coapplicant ? _c('div', {
    staticClass: "co-applicant-name pop-500"
  }, [_vm._v(" & "), _vm.mortgage.coapplicant.first_name !== '' ? _c('span', [_vm._v(" " + _vm._s(_vm.mortgage.coapplicant.first_name) + " " + _vm._s(_vm.mortgage.coapplicant.last_name) + " ")]) : _c('span', [_vm._v(" ID " + _vm._s(_vm.mortgage.coapplicant.id) + " ")])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "last-milestone mortgage-body",
    on: {
      "click": _vm.navigateToDetail
    }
  }, [_vm.mortgage ? _c('div', [_c('div', {
    staticClass: "light"
  }, [_vm._v(" " + _vm._s(_vm.getChoicesFromFormByKey("hlavny_ucel", _vm.mortgage && _vm.mortgage.hlavny_ucel ? _vm.mortgage.hlavny_ucel : _vm.mortgage.ciel_prva_analyza)) + " ")]), _c('div', {
    staticClass: "bold primary"
  }, [_vm._v(" " + _vm._s(_vm.getMortgageAmount(_vm.mortgage)) + " EUR ")])]) : _vm._e(), _c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/649145e2f83116b98203f321_open%20mortgage.svg",
      "loading": "lazy",
      "alt": ""
    }
  })]), _vm.role === 'alex_admin' ? _c('div', {
    staticClass: "w-inline-block mortgage-footer d-flex align-items-center justify-content-between"
  }, [_vm.client !== null ? _c('broker-picker-handler', {
    attrs: {
      "rules": ['priority'],
      "broker-id": _vm.client.financnik,
      "client-info": _vm.client.client_profile,
      "mortgage-id": _vm.mortgage.id,
      "mortgage-stage": _vm.stage,
      "mortgage-layout": "",
      "hypoteka": ""
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm.client.financnik ? _c('div') : _vm._e()], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }